(function () {
  var POLL_MS = 60000;
  // The form is now Shopify's {% form 'product' %} block (id="pdp-250-product-form").
  // Handle lives on the parent section as data-pdp-250-handle.
  var section = document.getElementById('pdp-250-buy-box');
  var form = document.getElementById('pdp-250-product-form');
  if (!form || !section) return;
  var handle = section.getAttribute('data-pdp-250-handle');
  if (!handle) return;
  var counters = document.querySelectorAll('[data-pdp-250-counter]');
  var mobileRemainings = document.querySelectorAll('[data-pdp-250-mobile-remaining]');
  var mobileBar = document.querySelector('[data-pdp-250-mobile-bar]');
  var sheet = document.querySelector('[data-pdp-250-sheet]');
  var sheetSlot = sheet ? sheet.querySelector('.pdp-250-buy-box__sheet-slot') : null;
  var buyBoxCard = document.querySelector('.pdp-250-buy-box__card');

  // ---- counter polling ----
  function updateCounters(total) {
    counters.forEach(function (el) {
      var span = el.querySelector('[data-pdp-250-remaining]');
      if (span) span.textContent = total;
    });
    mobileRemainings.forEach(function (span) { span.textContent = total; });
  }

  function hideCounters() {
    counters.forEach(function (el) { el.style.display = 'none'; });
    mobileRemainings.forEach(function (span) {
      var wrap = span.closest('.pdp-250-buy-box__mobile-bar-counter');
      if (wrap) wrap.style.display = 'none';
    });
  }

  function poll() {
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        var total = 0;
        var have = false;
        (data.variants || []).forEach(function (v) {
          if (typeof v.inventory_quantity === 'number') { total += v.inventory_quantity; have = true; }
        });
        if (!have) return; // silently keep server-rendered value
        if (total < 0) total = 0;
        updateCounters(total);
      })
      .catch(function () { hideCounters(); });
  }
  poll();
  setInterval(poll, POLL_MS);

  // ---- mobile bottom sheet ----
  var openBtn = document.querySelector('[data-pdp-250-mobile-open]');
  var closeEls = document.querySelectorAll('[data-pdp-250-sheet-close]');

  function openSheet() {
    if (!sheet || !buyBoxCard || !sheetSlot) return;
    // Move the card into the sheet slot on open, so all bindings persist
    if (sheetSlot.childElementCount === 0) sheetSlot.appendChild(buyBoxCard);
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    document.body.style.overflow = '';
    // Move card back into the section on close, so desktop sticky still works if user rotates
    var section = document.getElementById('pdp-250-buy-box');
    if (section && sheetSlot && sheetSlot.firstElementChild) {
      section.insertBefore(sheetSlot.firstElementChild, section.firstChild);
    }
  }
  if (openBtn) openBtn.addEventListener('click', openSheet);
  closeEls.forEach(function (el) { el.addEventListener('click', closeSheet); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  // ---- floating buy box (desktop only) ----
  // Card shows while the user is between the Statement section and the Close
  // section — the "product story" range. Re-hides if the user scrolls back up
  // into hero/statement, and again as the close section approaches.
  if (window.matchMedia && window.matchMedia('(min-width: 900px)').matches
      && buyBoxCard) {
    var whoSec = document.querySelector('.pdp-250-who');
    var statementSec = document.querySelector('.pdp-250-statement');
    var triggerSec = statementSec || document.getElementById('pdp-250-hero');
    var pastIntro = false;
    function syncFloating() {
      if (pastIntro) {
        buyBoxCard.classList.add('is-floating');
      } else {
        buyBoxCard.classList.remove('is-floating');
      }
    }
    // Reactive scroll check — pure scroll-position trigger, no dependency on
    // element rects (more reliable across layout changes). Card floats once
    // the user has scrolled past ~1.2 viewport heights (roughly past the
    // hero+statement intro block), toggles both directions.
    var introTicking = false;
    function computePastIntro() {
      introTicking = false;
      var scrollY = window.scrollY || window.pageYOffset;
      var next = scrollY > window.innerHeight * 1.2;
      if (next !== pastIntro) {
        pastIntro = next;
        syncFloating();
      }
    }
    function checkPastIntro() {
      if (introTicking) return;
      introTicking = true;
      window.requestAnimationFrame(computePastIntro);
    }
    window.addEventListener('scroll', checkPastIntro, { passive: true });
    window.addEventListener('resize', checkPastIntro);
    computePastIntro();
    // Pin-to-Who: as user scrolls, the card is `position: fixed; top: 50%`
    // (centered) until it would collide with Who. At that point it switches
    // to `position: absolute` locked to a specific PAGE Y position — so as
    // the user keeps scrolling, the card stays at that page position and
    // scrolls naturally off the top of the viewport (doesn't disappear via
    // opacity/hide; just slides out of view with the page).
    if (whoSec) {
      var GAP = 40;
      var pinTicking = false;
      function updateCardPin() {
        pinTicking = false;
        // Bail on mobile — pin logic is desktop-only. Clear any inline styles
        // that may have been set during a desktop→mobile resize.
        if (!window.matchMedia('(min-width: 900px)').matches) {
          buyBoxCard.style.position = '';
          buyBoxCard.style.top = '';
          buyBoxCard.style.transform = '';
          return;
        }
        if (!buyBoxCard.classList.contains('is-floating')) {
          buyBoxCard.style.position = '';
          buyBoxCard.style.top = '';
          buyBoxCard.style.transform = '';
          return;
        }
        var whoRect = whoSec.getBoundingClientRect();
        var scrollY = window.scrollY || window.pageYOffset;
        var cardH = buyBoxCard.offsetHeight;
        var vh = window.innerHeight;

        // Absolute page Y where Who's top sits.
        var whoAbsTop = whoRect.top + scrollY;
        // Max page Y where card's BOTTOM is allowed (leaving GAP above Who).
        var maxCardBottomAbs = whoAbsTop - GAP;
        // Where card's bottom would be if fixed-centered (in page coords).
        // With top:50% + translateY(-50%): card center = viewport center = vh/2 + scrollY.
        // Card bottom = center + cardH/2.
        var centeredBottomAbs = scrollY + vh / 2 + cardH / 2;

        if (centeredBottomAbs <= maxCardBottomAbs) {
          // No collision — centered fixed (CSS defaults).
          buyBoxCard.style.position = '';
          buyBoxCard.style.top = '';
          // NB: don't touch transform — CSS keeps translateY(-50%) intact.
        } else {
          // Pin: lock to page position so it scrolls with page.
          // Keep CSS transform (translateY(-50%)) unchanged so no bounce —
          // just move `top` down by cardH/2 to compensate for that shift.
          buyBoxCard.style.position = 'absolute';
          buyBoxCard.style.top = (maxCardBottomAbs - cardH / 2) + 'px';
        }
      }
      function onScrollOrResize() {
        if (!pinTicking) {
          pinTicking = true;
          window.requestAnimationFrame(updateCardPin);
        }
      }
      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);
      new MutationObserver(updateCardPin).observe(buyBoxCard, { attributes: true, attributeFilter: ['class'] });
      // React to viewport crossing the desktop breakpoint so stale inline
      // styles clear the instant we drop to mobile.
      var mq = window.matchMedia('(min-width: 900px)');
      var mqHandler = function () { updateCardPin(); };
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', mqHandler);
      else if (typeof mq.addListener === 'function') mq.addListener(mqHandler);
      updateCardPin();
    }
  }

  // ---- hero + close CTA behavior ----
  // Anchor-scrolls to the buy box (browser handles smooth scroll via CSS),
  // then pulses the card and focuses the first available swatch input so
  // the buyer's eye + keyboard land on the color choice immediately.
  document.querySelectorAll('[data-pdp-250-cta="hero"], [data-pdp-250-cta="close"]').forEach(function (cta) {
    cta.addEventListener('click', function () {
      setTimeout(function () {
        if (!buyBoxCard) return;
        buyBoxCard.classList.remove('is-highlighted');
        void buyBoxCard.offsetWidth;  // force reflow to replay animation
        buyBoxCard.classList.add('is-highlighted');

        var firstInput = form.querySelector('input[name="id"]:not(:disabled)');
        if (firstInput) firstInput.focus({ preventScroll: true });
      }, 450);   // let the smooth-scroll settle before pulsing
    });
  });
})();
